import React from "react";
import "./Education.css";

export default function Education({ data }) {
  return (
    <section id="education" className="education section">
      <div className="container">
        <span className="section-label">02 — Education</span>
        <h2 className="section-title">Academic<br />Background</h2>

        <div className="edu__card">
          <div className="edu__icon">🎓</div>
          <div className="edu__body">
            <div className="edu__header">
              <h3 className="edu__degree">{data.degree}</h3>
              <span className="edu__gpa">{data.gpa}</span>
            </div>
            <p className="edu__dept">{data.dept}</p>
            <p className="edu__school">{data.school}</p>
            <span className="edu__status">{data.status}</span>
            <div className="edu__courses">
              {data.courses.map((c) => (
                <span key={c} className="edu__course-tag">{c}</span>
              ))}
            </div>
          </div>
        </div>

        {/* timeline decoration */}
        <div className="edu__timeline">
          <div className="edu__timeline-line" />
          <div className="edu__timeline-node" />
          <span className="edu__timeline-label">Present</span>
        </div>
      </div>
    </section>
  );
}
